import { isEmpty } from 'lodash';
import React from 'react';
import { searchFilterContentTypeToContentClass, } from '../NavSearchElements/NavSearchTypes';
import AdobePluginSuggestion from './AdobePluginSuggestion';
import AutoSuggestDropdown from './AutoSuggestDropdown';
import CollectionsSuggestion from './CollectionsSuggestion';
import { suggestionTypesKey } from './Constants';
import KeywordsSuggestion from './KeywordsSuggestion';
import RelatedContentSuggestion from './RelatedContentSuggestion';
import WithinAssetSuggestion from './WithinAssetSuggestion';
const PopulatedSearchDropdown = ({ showSuggestions = false, autoSuggestDropdownProps = {}, keywordsSuggestionProps = {}, collectionsSuggestionProps = {}, withinAssetSuggestionProps = {}, relatedContentSuggestionProps = {}, adobeSuggestionProps, suggestions = {
    keywords: [],
    relatedCollections: [],
    withinAssetContentTypeSuggestions: [],
    relatedContentTypeSuggestion: [],
    suggestedPages: [],
}, contentType, useNewSearchUI, }) => {
    return (<AutoSuggestDropdown show={showSuggestions} className={`flex flex-col ${!isEmpty(suggestions === null || suggestions === void 0 ? void 0 : suggestions.keywords) &&
            isEmpty(suggestions === null || suggestions === void 0 ? void 0 : suggestions.relatedContentTypeSuggestion) &&
            isEmpty(suggestions === null || suggestions === void 0 ? void 0 : suggestions.withinAssetContentTypeSuggestions) &&
            isEmpty(suggestions === null || suggestions === void 0 ? void 0 : suggestions.relatedCollections)
            ? 'w-full'
            : ''}`} {...autoSuggestDropdownProps} useNewSearchUI={useNewSearchUI}>
      <div className={useNewSearchUI
            ? 'flex flex-col lg:flex-row gap-6 lg:gap-0 h-144 lg:h-auto overflow-y-scroll lg:overflow-visible'
            : 'flex flex-row space-x-0.5'}>
        <div className={useNewSearchUI
            ? 'flex-grow flex-shrink-0 flex flex-col mr-8 lg:w-38'
            : 'w-32vw lg:w-61 flex-grow flex-shrink flex flex-col space-y-2'}>
          <KeywordsSuggestion keywords={suggestions.keywords} {...keywordsSuggestionProps} useNewSearchUI={useNewSearchUI}/>
        </div>
        <div className={useNewSearchUI
            ? 'flex flex-col flex-grow space-y-5'
            : 'flex flex-col flex-grow py-5 space-y-5 pr-8'}>
          <WithinAssetSuggestion {...withinAssetSuggestionProps} contentClass={searchFilterContentTypeToContentClass[contentType]} withinAssetContentTypeSuggestions={suggestions.withinAssetContentTypeSuggestions} useNewSearchUI={useNewSearchUI}/>
          <RelatedContentSuggestion {...relatedContentSuggestionProps} relatedContentTypeSuggestions={suggestions.relatedContentTypeSuggestion} useNewSearchUI={useNewSearchUI}/>
          <CollectionsSuggestion collections={suggestions.relatedCollections} title="Related Collections" getTelemetryString={(routeUri) => `typeahead.collection.${routeUri}.click`} idLabel={`${suggestionTypesKey.RELATED_COLLECTION}`} {...collectionsSuggestionProps} useNewSearchUI={useNewSearchUI}/>
        </div>
      </div>
      <AdobePluginSuggestion searchTerm={keywordsSuggestionProps.searchTerm} variant={adobeSuggestionProps.variant} show={adobeSuggestionProps.show} useNewSearchUI={useNewSearchUI}/>
    </AutoSuggestDropdown>);
};
export default PopulatedSearchDropdown;
